module.exports = "https://s.pinimg.com/webapp/style/images/SV@2x-16c717a4.png";